module.exports = __webpack_public_path__ + "h5/img/examine.70b662a8.png";